import { useAppSelector } from "src/hooks/redux";
import SuggestedForm from "../calculo-sugeridos/suggested-form/suggested-form";
import { BodyCartArea, CheckoutCartArea, WrapperCommercialCart } from "./CommercialCart.styles";
import { selectDataSuggested } from "src/redux/shopping_cart/shopping_cart.selectors";
import MonthPeriodSelect from "./MonthPeriodSelect";
import OrderSummary from "./OrderSummary";
import PaymentMethodSelect from "./PaymentMethodSelect";
import ProducsSelectable from "./ProducsSelectable/ProducsSelectable";


const CommercialCart = () => {
    const { suggested } = useAppSelector(selectDataSuggested);
    

    return (
        <WrapperCommercialCart>
            <BodyCartArea>
                <SuggestedForm />
                {suggested.users.email !== "" && (
                    <>
                        <MonthPeriodSelect />
                        <ProducsSelectable />
                    </>
                )}
            </BodyCartArea>
            <CheckoutCartArea>
                <PaymentMethodSelect />
                <OrderSummary />
            </CheckoutCartArea>
        </WrapperCommercialCart>
    );
};

export default CommercialCart;
